import clsx from "clsx";
import React from "react";
import styles from "./styles.module.scss";

const Label = React.forwardRef<
  HTMLLabelElement,
  React.LabelHTMLAttributes<HTMLLabelElement>
>(({ className, ...props }, ref) => {
  return (
  <label className={clsx(styles._onetouchai_label, className)} {...props} ref={ref} />
  );
});
Label.displayName = "Label";

export { Label };
